import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OtaBatchCreateComponent } from './ota-batch-create.component';

const routes: Routes = [
  {
    path: 'ota-batch-create',
    component: OtaBatchCreateComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchCreateRoutingModule {}
